<nav id="sasMenu" class="d-print-none sidebar inactive" aria-expanded="false" aria-label="Main navigation">
  <div class="nav nav-sidebar">
    @if (!menuService.isLandpageHidden()) {
      <div class="menu-item" tabindex="-1">
        <a [routerLink]="[clientUrl + '/' + landpage.value]"
           routerLinkActive="active"
           [attr.data-opt]="landpage.code"
           class="{{landpage.code}}"
           (focus)="ensureOpen()"
           (click)="selectOption(landpage)"
           tabindex="{{tabIndex}}">
          <div class="menuIcon"></div>
          <span [innerText]="landpage.code" translate="{{landpage.code}}"></span>
        </a>
      </div>
    }
    @for (opt of items | orderBy : 'index'; track opt.index; let idx = $index, e = $even) {
    <div class="menu-item" tabindex="-1">
      @if (!opt.external && opt.code !== SIGN_OUT_CODE && opt.code !== SIGN_IN_CODE){
      <a [routerLink]="[clientUrl + '/' + serviceUrl + '/' + opt.value]"
         [attr.data-opt]="opt.code"
         class="{{opt.code}}"
         [class.active]="isMenuActive(opt)"
         (focus)="ensureOpen()"
         (click)="selectOption(opt)"
         tabindex="{{tabIndex}}">
        <div class="menuIcon"></div>
        <span [innerText]="opt.code" translate="{{opt.code}}"></span>
      </a>
      }
      @else if (!opt.external && opt.code === SIGN_IN_CODE){
      <a [routerLink]="[clientUrl + '/' + opt.value]"
         [attr.data-opt]="opt.code"
         class="{{opt.code}}"
         [class.active]="isMenuActive(opt)"
         (focus)="ensureOpen()"
         (click)="selectOption(opt)"
         tabindex="{{tabIndex}}">
        <div class="menuIcon"></div>
        <span [innerText]="opt.code" translate="{{opt.code}}"></span>
      </a>
      }
      @else if (!opt.external && opt.code === SIGN_OUT_CODE){
      <a [attr.data-opt]="opt.code"
         class="{{opt.code}}"
         (focus)="ensureOpen()"
         (click)="signOut()"
         tabindex="{{tabIndex}}">
        <div class="menuIcon"></div>
        <span [innerText]="opt.code" translate="{{opt.code}}"></span>
      </a>
      }
      @else{
      <a href="{{opt.value}}"
         target="_blank"
         [attr.data-opt]="opt.code"
         class="{{opt.code}}"
         [class.active]="isMenuActive(opt)"
         (focus)="ensureOpen()"
         (click)="selectOption(opt)"
         tabindex="{{tabIndex}}">
        <div class="menuIcon"></div>
        <span [innerText]="opt.code" translate="{{opt.code}}"></span>
      </a>
      }
    </div>
    }
  </div>
</nav>
